"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Empty = exports.useTableField = void 0;
const react_1 = __importStar(require("react"));
const lodash_1 = require("lodash");
const uuid_1 = require("uuid");
const table_field_toolbar_1 = require("./table-field-toolbar");
const table_field_header_1 = require("./table-field-header");
const table_field_row_1 = require("./table-field-row");
const table_field_dialog_1 = require("./table-field-dialog");
const table_field_remove_dialog_1 = require("./table-field-remove-dialog");
const event_callback_hook_1 = require("../../utils/event-callback-hook");
const array_move_1 = require("../../utils/array-move");
const react_intl_1 = require("react-intl");
const form_number_field_1 = require("../../composite/form/fields/form-number-field");
const inline_table_context_1 = require("../inline-table-field/inline-table-context");
const form_context_1 = require("../../composite/form/form-context");
function useTableField(options) {
    var _a;
    const intl = react_intl_1.useIntl();
    const inlineTableFieldContext = react_1.useContext(inline_table_context_1.InlineTableFieldContext);
    const formContext = react_1.useContext(form_context_1.FormContext);
    const defaultInitNewItem = event_callback_hook_1.useEventCallback(() => {
        var _a;
        const object = {
            id: uuid_1.v4(),
        };
        if (props.useOrderColumn) {
            const lastOrder = (_a = lodash_1.max(value.map((item) => lodash_1.get(item, props.orderColumnPath)))) !== null && _a !== void 0 ? _a : 0;
            lodash_1.set(object, props.orderColumnPath, lastOrder + 1);
        }
        return object;
    });
    const props = {
        showToolbar: true,
        disabled: false,
        disabledAdd: false,
        disabledEdit: false,
        disabledRemove: false,
        visibleAdd: true,
        visibleEdit: true,
        visibleRemove: true,
        visibleActionsColumn: true,
        useDnDOrdering: false,
        useOrderColumn: false,
        orderColumnPath: 'order',
        maxRows: 10,
        noMinHeigth: false,
        createRowStyle: react_1.useMemo(() => () => ({}), []),
        onSelect: lodash_1.noop,
        initNewItem: defaultInitNewItem,
        showDetailBtnCond: lodash_1.stubTrue,
        showRadioCond: lodash_1.stubTrue,
        ToolbarComponent: table_field_toolbar_1.TableFieldToolbar,
        HeaderComponent: table_field_header_1.TableFieldHeader,
        RowComponent: table_field_row_1.TableFieldRow,
        DialogComponent: table_field_dialog_1.TableFieldDialog,
        RemoveDialogComponent: table_field_remove_dialog_1.TableFieldRemoveDialog,
        ...options,
        columns: react_1.useMemo(() => {
            var _a;
            return lodash_1.compact([
                options.useOrderColumn
                    ? {
                        name: intl.formatMessage({
                            id: 'EAS_TABLE_FIELD_COLUMN_ORDER',
                            defaultMessage: 'Pořadí',
                        }),
                        datakey: (_a = options.orderColumnPath) !== null && _a !== void 0 ? _a : 'order',
                        width: 100,
                        visible: true,
                    }
                    : undefined,
                ...options.columns,
            ]);
        }, [intl, options.columns, options.orderColumnPath, options.useOrderColumn]),
        FormFieldsComponent: react_1.useMemo(() => function FormFieldsComponent(props) {
            var _a;
            return (react_1.default.createElement(react_1.default.Fragment, null,
                options.useOrderColumn && (react_1.default.createElement(form_number_field_1.FormNumberField, { name: (_a = options.orderColumnPath) !== null && _a !== void 0 ? _a : 'order', disabled: true, label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_TABLE_FIELD_FIELD_LABEL_ORDER", defaultMessage: "Po\u0159ad\u00ED" }), helpLabel: intl.formatMessage({
                        id: 'EAS_TABLE_FIELD_FIELD_HELP_ORDER',
                        defaultMessage: ' ',
                    }) })),
                options.FormFieldsComponent && (react_1.default.createElement(options.FormFieldsComponent, Object.assign({}, props)))));
        }, [
            intl,
            options.FormFieldsComponent,
            options.orderColumnPath,
            options.useOrderColumn,
        ]),
    };
    const value = (_a = props.value) !== null && _a !== void 0 ? _a : [];
    const [selectedIndex, setSelectedIndex] = react_1.useState();
    const [columnsState, setColumnsState] = react_1.useState(deriveColumnsState(props.columns));
    const formDialogRef = react_1.useRef(null);
    const removeDialogRef = react_1.useRef(null);
    const showAddDialog = event_callback_hook_1.useEventCallback(() => {
        var _a;
        setSelectedIndex(undefined);
        (_a = formDialogRef.current) === null || _a === void 0 ? void 0 : _a.open();
    });
    const showEditDialog = event_callback_hook_1.useEventCallback((index) => {
        var _a;
        setSelectedIndex(index);
        (_a = formDialogRef.current) === null || _a === void 0 ? void 0 : _a.open();
    });
    const showRemoveDialog = event_callback_hook_1.useEventCallback((index) => {
        var _a;
        setSelectedIndex(index);
        (_a = removeDialogRef.current) === null || _a === void 0 ? void 0 : _a.open();
    });
    const showDetailDialog = event_callback_hook_1.useEventCallback((index) => {
        var _a;
        setSelectedIndex(index);
        (_a = formDialogRef.current) === null || _a === void 0 ? void 0 : _a.open();
    });
    const saveRow = event_callback_hook_1.useEventCallback((index, object) => {
        let newValue;
        if (index !== undefined) {
            newValue = [
                ...value.slice(undefined, index),
                object,
                ...value.slice(index + 1, undefined),
            ];
        }
        else {
            newValue = [...value, object];
        }
        props.onChange(newValue);
    });
    const removeRow = event_callback_hook_1.useEventCallback((index) => {
        let newValue = value.filter((_, i) => i !== index);
        if (props.useOrderColumn) {
            // recalculate order for every item
            newValue = newValue.map((item, i) => {
                const newItem = { ...item };
                lodash_1.set(newItem, props.orderColumnPath, i + 1);
                return newItem;
            });
        }
        props.onChange(newValue);
        setSelectedIndex(undefined);
    });
    const selectRow = event_callback_hook_1.useEventCallback((index) => {
        if (index !== selectedIndex) {
            setSelectedIndex(index);
            if (props.value != null) {
                props.onSelect(props.value[index], index);
            }
        }
        else {
            setSelectedIndex(undefined);
            props.onSelect(null, index);
        }
    });
    const setColumnWidth = event_callback_hook_1.useEventCallback((datakey, width) => {
        setColumnsState((columnsState) => {
            var _a;
            const index = columnsState.findIndex((column) => column.datakey === datakey);
            if (index !== -1) {
                return [
                    ...columnsState.slice(0, index),
                    {
                        ...columnsState[index],
                        width: Math.max((_a = props.columns[index].minWidth) !== null && _a !== void 0 ? _a : 50, width),
                    },
                    ...columnsState.slice(index + 1, undefined),
                ];
            }
            else {
                return columnsState;
            }
        });
    });
    const actionButtonWidth = 20;
    const actionColumnWidth = react_1.useMemo(() => {
        let actionButtonsCount = 0;
        if (!props.disabled && props.useDnDOrdering) {
            actionButtonsCount++;
        }
        // this is ugly, but necessary for counting the action column items. Should be reworked somehow else.
        if ((inlineTableFieldContext === null || inlineTableFieldContext === void 0 ? void 0 : inlineTableFieldContext.withRemove) && (formContext === null || formContext === void 0 ? void 0 : formContext.editing) &&
            !props.disabled) {
            actionButtonsCount++;
        }
        for (const row of value) {
            if (!props.disabled && props.showRadioCond(row)) {
                actionButtonsCount++;
                break;
            }
        }
        for (const row of value) {
            if (props.disabled && props.showDetailBtnCond(row)) {
                actionButtonsCount++;
                break;
            }
        }
        return actionButtonsCount > 0
            ? actionButtonsCount * actionButtonWidth + 15
            : 0;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        props.disabled,
        props.useDnDOrdering,
        props.showRadioCond,
        props.showDetailBtnCond,
        inlineTableFieldContext === null || inlineTableFieldContext === void 0 ? void 0 : inlineTableFieldContext.withRemove,
        formContext === null || formContext === void 0 ? void 0 : formContext.editing,
        value,
    ]);
    /**
     * Swaps rows positions and optionaly also order attribute.
     */
    const swapRows = event_callback_hook_1.useEventCallback(({ oldIndex, newIndex }) => {
        const newValue = array_move_1.arrayMove(value, oldIndex, newIndex);
        if (props.useOrderColumn) {
            const oldRow = { ...newValue[oldIndex] };
            const newRow = { ...newValue[newIndex] };
            newValue[oldIndex] = oldRow;
            newValue[newIndex] = newRow;
            const oldRowNum = lodash_1.get(oldRow, props.orderColumnPath);
            const newRowNum = lodash_1.get(newRow, props.orderColumnPath);
            lodash_1.set(oldRow, props.orderColumnPath, newRowNum);
            lodash_1.set(newRow, props.orderColumnPath, oldRowNum);
        }
        props.onChange(newValue);
    });
    const filteredColumns = columnsState
        .map((state) => {
        const column = props.columns.find((column) => column.datakey === state.datakey);
        return column !== undefined ? { ...column, ...state } : undefined;
    })
        .filter((column) => column !== undefined)
        .map((column) => column)
        .filter((column) => column.visible || column.visible === undefined);
    const context = react_1.useMemo(() => ({
        disabled: props.disabled,
        columns: props.columns,
        value,
        disabledAdd: props.disabledAdd,
        disabledEdit: props.disabledEdit,
        disabledRemove: props.disabledRemove,
        visibleAdd: props.visibleAdd,
        visibleEdit: props.visibleEdit,
        visibleRemove: props.visibleRemove,
        visibleActionsColumn: props.visibleActionsColumn,
        onSelect: props.onSelect,
        columnsState,
        filteredColumns,
        showAddDialog,
        showEditDialog,
        showRemoveDialog,
        showDetailDialog,
        saveRow,
        removeRow,
        selectRow,
        setColumnWidth,
        actionColumnWidth,
        showDetailBtnCond: props.showDetailBtnCond,
        showRadioCond: props.showRadioCond,
        initNewItem: props.initNewItem,
        useDnDOrdering: props.useDnDOrdering,
        createRowStyle: props.createRowStyle,
    }), [
        columnsState,
        filteredColumns,
        props.columns,
        props.disabled,
        props.disabledAdd,
        props.disabledEdit,
        props.disabledRemove,
        props.initNewItem,
        props.onSelect,
        props.showDetailBtnCond,
        props.showRadioCond,
        props.visibleAdd,
        props.visibleEdit,
        props.visibleRemove,
        props.visibleActionsColumn,
        removeRow,
        saveRow,
        selectRow,
        actionColumnWidth,
        setColumnWidth,
        showAddDialog,
        showDetailDialog,
        showEditDialog,
        showRemoveDialog,
        value,
        props.useDnDOrdering,
        props.createRowStyle,
    ]);
    return {
        props,
        context,
        selectedIndex,
        setSelectedIndex,
        formDialogRef,
        removeDialogRef,
        swapRows,
    };
}
exports.useTableField = useTableField;
function Empty() {
    return react_1.default.createElement(react_1.default.Fragment, null);
}
exports.Empty = Empty;
function deriveColumnsState(columns) {
    return columns.map((column) => ({
        datakey: column.datakey,
        width: column.width,
    }));
}
//# sourceMappingURL=table-field-hook.js.map